exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.l-section {\n    position: relative;\n    height: 100%;\n    z-index: 1;\n}\n\n", ""]);
